const CREATE_BADGE = `
mutation CreateBadge($awarder: String, $badgeTypeId: BadgeTypeId!, $description: String!, $recipient: String!, $studentId: ID!, $classId: ID, $schoolId: [ID!]!, $rewardLevelId: RewardLevelId!, $locale: BadgeLocale) {
  createStudentBadge(input: {badgeTypeId: $badgeTypeId, description: $description, recipient: $recipient, rewardLevelId: $rewardLevelId, classId: $classId, schoolId: $schoolId, studentId: $studentId, awarder: $awarder, awarded: true, locale: $locale}) {
    studentId
    seen
    schoolId
    rewardLevelId
    recipient
    id
    description
    createdAtDate
    createdAt
    badgeTypeId
    awarder
    awardedAt
    awarded
    classId
    locale
  }
}
`

export default CREATE_BADGE;